// src/services/omniStackApi.js
import axios from 'axios';
import { Config } from '../constants';

// Create a new axios instance for the Omnistack API
const omniStackApi = axios.create({
    baseURL: Config.OMNI_GATEWAY_URL || 'https://apigtw.omnistackhub.xyz/',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        'x-api-key': Config.OMNI_GATEWAY_API_KEY || ''
    }
});

// Add a response interceptor to handle common errors
omniStackApi.interceptors.response.use(
    response => response,
    error => {
        // Handle specific errors here if needed
        return Promise.reject(error.response ? error.response.data : error);
    }
);

export default omniStackApi;